import React from 'react';
export interface ShareRow {
  label: string;
  share: number;
  detail?: string;
}
interface ShareBreakdownProps {
  rows: ShareRow[];
}
export function ShareBreakdown({
  rows
}: ShareBreakdownProps) {
  return <ul className="space-y-3" data-id="element-440" data-mp="3eu81nczossk0">
      {rows.map(row => <li key={row.label} data-id="element-441" data-mp="39w6k4whwt1an">
          <div className="flex items-baseline justify-between gap-4" data-id="element-442" data-mp="39wyhabr5n731">
            <span className="text-sm text-foreground" data-id="element-443" data-mp="34x2dacigjfnh">{row.label}</span>
            <span className="font-mono text-xs tabular-nums text-muted-foreground" data-id="element-444" data-mp="34ydgaa42wjdj">
              {row.detail ? `${row.detail} · ` : ''}
              {Math.round(row.share * 100)}%
            </span>
          </div>
          <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-muted" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(row.share * 100)} aria-label={row.label} data-id="element-445" data-mp="2vy8hupgv4vbi">
            <div className="h-full rounded-full bg-foreground" style={{
          width: `${Math.round(row.share * 100)}%`
        }} data-id="element-446" data-mp="p3v2sy969q6l" />
          </div>
        </li>)}
    </ul>;
}